<section id="main" style="min-height: 200px">
  <ng-container #mainContainer></ng-container>
</section>
<section id="services" style="min-height: 200px">
  <ng-container #servicesContainer></ng-container>
</section>
<section id="team" style="min-height: 200px">
  <ng-container #teamContainer></ng-container>
</section>
<section id="projects" style="min-height: 200px">
  <ng-container #projectsContainer></ng-container>
</section>
<section id="questions" style="min-height: 150px">
  <ng-container #questionsContainer></ng-container>
</section>
<section id="contacts" style="min-height: 200px">
  <ng-container #contactsContainer></ng-container>
</section>
